import {ICON_TYPES} from '../constants';

export const CentralHeatingIcon = (): JSX.Element => {
  return (
    <svg
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path
          d='M8.75002 18.5815L5.91064 12.9019L0.231018 10.0625L5.91064 7.22312L8.75002 1.5435L11.5894 7.22312L17.269 10.0625L11.5894 12.9019L8.75002 18.5815ZM4.14402 10.0625L7.21439 11.5981L8.75002 14.6685L10.2856 11.5981L13.356 10.0625L10.2856 8.52687L8.75002 5.4565L7.21439 8.52687L4.14402 10.0625ZM15.75 18.375L17.0625 21L18.375 18.375L21 17.0625L18.375 15.75L17.0625 13.125L15.75 15.75L13.125 17.0625L15.75 18.375ZM16.9164 4.08362L17.9375 6.125L18.9586 4.08362L21 3.0625L18.9586 2.04137L17.9375 0L16.9164 2.04137L14.875 3.0625L16.9164 4.08362Z'
          fill='#43494F'
        />
      </g>
    </svg>
  );
};

CentralHeatingIcon.iconType = ICON_TYPES.CENTRAL_HEATING;
